(function () {
  if (window.cardProductNewInitialized) return;
  window.cardProductNewInitialized = true;

  function setAccessorySelected(accessory) {
    accessory.classList.toggle('is-selected');
    accessory.setAttribute('aria-checked', accessory.classList.contains('is-selected') ? 'true' : 'false');
  }

  function getCardScope(element) {
    return element.closest('.card-wrapper') || element.closest('.card') || null;
  }

  function getMainVariantId(button) {
    return button.dataset.variants || button.dataset.variantId || '';
  }

  function getCardCartItems(button) {
    var mainVariantId = getMainVariantId(button);
    if (!mainVariantId) return [];

    var items = [{ id: mainVariantId, quantity: 1 }];
    var scope = getCardScope(button);
    if (!scope) return items;

    scope.querySelectorAll('.card-accessory.is-selected[data-accessory-variant-id]').forEach(function (accessory) {
      var accessoryVariantId = accessory.dataset.accessoryVariantId;

      if (accessoryVariantId && String(accessoryVariantId) !== String(mainVariantId)) {
        items.push({ id: accessoryVariantId, quantity: 1 });
      }
    });

    return items;
  }

  async function addCardItems(button, goToCheckout) {
    var items = getCardCartItems(button);
    var discountCode = (button.dataset.discount || '').trim();
    if (!items.length || button.disabled || button.classList.contains('loading')) return;

    if (!window.iGardenCart) {
      console.error('[Card Cart] iGardenCart is unavailable.');
      return;
    }

    button.classList.add('loading');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');

    try {
      if (goToCheckout) {
        await window.iGardenCart.buyNow(items, {
          activeElement: button,
          discountCode: discountCode
        });
      } else {
        await window.iGardenCart.addItems(items, {
          activeElement: button,
          discountCode: discountCode
        });
      }
    } catch (error) {
      console.error('[Card Cart] Error:', error);
    } finally {
      button.classList.remove('loading');
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
    }
  }

  document.addEventListener('click', function (event) {
    var accessory = event.target.closest('[data-card-product-new-grid] .card-accessory[data-accessory-variant-id]');

    if (accessory) {
      event.preventDefault();
      setAccessorySelected(accessory);
      return;
    }

    var addButton = event.target.closest('[data-card-product-new-grid] [data-card-add-to-cart]');
    var buyNowButton = event.target.closest('[data-card-product-new-grid] [data-card-buy-with-accessories]');
    var button = addButton || buyNowButton;
    if (!button || button.disabled || button.classList.contains('loading')) return;

    event.preventDefault();
    event.stopPropagation();
    addCardItems(button, Boolean(buyNowButton));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    var accessory = event.target.closest('[data-card-product-new-grid] .card-accessory[data-accessory-variant-id]');
    if (!accessory) return;

    event.preventDefault();
    setAccessorySelected(accessory);
  });
})();
